import * as yup from "yup";

// const passwordRegExp = /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=!]).*$/;

const LoginVS = yup.object().shape({
  email: yup
    .string()
    .required("Email is Required")
    .email("Invalid Email")
    .label("email"),
  password: yup.string().required("Password is Required").label("password"),
});

//

interface FileWithSize extends File {
  size: number;
  type: string;
}

const blogValidationSchema = yup.object().shape({
  title: yup
    .string()
    .required("Title is required")
    .min(3, "Title must be at least 3 characters")
    .max(100, "Title must not exceed 100 characters"),
  content: yup
    .string()
    .required("Content is required")
    .min(10, "Content must be at least 10 characters"),
  thumbnail: yup
    .mixed()
    .nullable()
    .test("fileSize", "File size is too large", (value) => {
      if (!value) return true; // Allow null for updates
      const file = value as FileWithSize;
      return file.size <= 5242880; // 5MB
    })
    .test("fileType", "Unsupported file type", (value) => {
      if (!value) return true; // Allow null for updates
      const file = value as FileWithSize;
      return ["image/jpeg", "image/png", "image/gif"].includes(file.type);
    }),
});

export { LoginVS, blogValidationSchema };
